import React, { useMemo } from 'react';
import { inject, provider, useInstance } from 'react-ioc';
import { observer } from 'mobx-react';
import Api from 'api';
import { BaseFilter } from '@axl/accel-framework/models';
import { CRUDListStore } from '@axl/accel-framework/stores/ListStore';
import { ClickIdentifierApi } from 'api/methods/partnership';
import { SelectAsync } from '@axl/accel-framework/components';
import { SelectAsyncExternalProps } from '@axl/accel-framework/components/Select2';
import { useLoc } from 'components';
import { combineRefs } from '@axl/accel-framework/utils';

export declare type ClickIdentifierValue = string;
export declare type ClickIdentifierType = 'gclid' | 'fbclid' | 'msclkid' | 'ttclid';

export class ClickIdentifierFilter extends BaseFilter<ClickIdentifierValue> {
    constructor(filter?: Partial<ClickIdentifierFilter>) {
        super();
        if (filter) this.update(filter);
    }

    type: ClickIdentifierType;

    update(changes: Partial<ClickIdentifierFilter>) {
        super.update(changes);
    }
}

//@ts-ignore
export class ClickIdentifiersStore extends CRUDListStore<ClickIdentifierValue, ClickIdentifierFilter, ClickIdentifierApi> {

    constructor(private api: Api) {
        super('paging', false);
        this.api = api || inject(this, Api);
    }

    get crudApi(): ClickIdentifierApi {
        return this.api.partnership.clickIdentifiers;
    }

    createFilter(p: Partial<ClickIdentifierFilter>) {
        return new ClickIdentifierFilter({ ...this.filter, ...p });
    }
}

//@ts-ignore
export type ClickIdentifierSelectProps = SelectAsyncExternalProps<ClickIdentifierValue, ClickIdentifierFilter> & {
    filter: Partial<ClickIdentifierFilter>;
}

const ClickIdentifierSelect: React.FC<ClickIdentifierSelectProps> = (props) => {
    const loc = useLoc();
    const store = useInstance(ClickIdentifiersStore);
    const selectRef = SelectAsync.useRef();

    useMemo(() => {
        store.updateFilter(props.filter);
        selectRef.current?.clearCache();
    }, [props.filter]);

    return <SelectAsync {...props}
        selectRef={combineRefs(props.selectRef, selectRef)}
        //@ts-ignore
        store={store}
        //@ts-ignore
        itemKey={x => x}
        ref={props.selectRef}
        placeholder={loc.word('ClickIdentifiersSelector.placeholder', { default: 'Select click IDs' })}
        itemLabel={x => x}
    />;
}

export default provider(ClickIdentifiersStore)(observer(ClickIdentifierSelect));
